export default "__VITE_ASSET__ClrGcAGd__"